import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://ndrbtpggwauwnbtocrgz.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5kcmJ0cGdnd2F1d25idG9jcmd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0ODI1NjEsImV4cCI6MjA5MzA1ODU2MX0.XnG88gi-3hGKjm92yF-pyAt9jdd1ROAYGwUk06RPg-Y'
);